<template>
    <section>
        <h1>Unauthorized</h1>
    </section>
</template>